module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_7016.899c036f.png";